// extracted by mini-css-extract-plugin
export default {"Buttons":"PostButtons_Buttons__4JluM","SocialButtons":"PostButtons_SocialButtons__CtSKB","LikeActive":"PostButtons_LikeActive__k+9LO","CopyButton":"PostButtons_CopyButton__nqPhh"};